var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidbear-settings-group',{attrs:{"title":"Post Thumbnail","active":""}},[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":_vm.className(' .post-thumb-container > div'),"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Image Width","var":"--width","measurement":"width"}}),_c('sid-range-slider',{attrs:{"rule-name":"height","sid":_vm.className(' .post-thumb-container .post-thumb'),"default-dimension":"px","dimensions":['vw', 'px'],"label":"Image Height","var":"--height","measurement":"height"}}),_c('sid-align',{attrs:{"sid":_vm.className(' .post-thumb-container'),"rule-name":"justify-content","label":"Alignment"}})],1),_c('sidbear-settings-group',{attrs:{"title":"Filters"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-background-filters',{attrs:{"sid":_vm.className(' .post-thumb'),"rule-name":"filter"}}),_c('sid-range-slider',{attrs:{"label":"Opacity","sid":_vm.className(' .post-thumb'),"rule-name":"opacity","default-dimension":'',"dimensions":[],"min":0,"max":1,"step":0.1}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-checkbox',{attrs:{"value":".3s","unchecked-value":"","rule-name":"transition","var":"--transition","sid":_vm.className(' .post-thumb')}},[_vm._v(" Transition "),_c('span',{staticClass:"bg-primary text-center ml-2 px-2 text-white h-[17px] w-[50px] rounded-pill text-[12px] font-normal"},[_vm._v("BETA")])]),_c('sid-background-filters',{attrs:{"sid":_vm.className(),"rule-name":"filter","presudo":" .post-grid-card:hover .post-thumb"}}),_c('sid-range-slider',{attrs:{"label":"Opacity","sid":_vm.className(),"rule-name":"opacity","default-dimension":'',"dimensions":[],"min":0,"max":1,"presudo":" .post-grid-card:hover .post-thumb","step":0.1}})]},proxy:true}])})],1),_c('sidbear-settings-group',{attrs:{"title":"Border & Radius"}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' .post-thumb'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' .post-thumb'),"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' .post-thumb'),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":_vm.className(' .post-thumb'),"rule-name":"border","angles":[
        {
          text: '',
          value: 'top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius'
        }
      ]}})],1),_c('sidbear-settings-group',{attrs:{"title":"Drop Shadow"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":_vm.className(' .post-thumb'),"rule-name":"box-shadow"}})],1)],1),_c('sidbear-settings-group',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .post-thumb-container'),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(' .post-thumb-container'),"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }